import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function TableContent({ headers }) {
  const vehicleTrackingReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { qualityCheckList } = vehicleTrackingReducer;

  const navigate = useNavigate();

  const moveToDetail = (value) => {
    navigate(`/quality-check-detail/${value}`);
  };
  return (
    <tbody>
      {qualityCheckList && qualityCheckList.length > 0 ? (
        qualityCheckList.map((dimensionObj) => (
          <tr key={dimensionObj.quality_check_id}>
            {headers.map((header) => (
              <td className="table-data" key={header.value}>
                <div className="div-flex-row">
                  {header.value === 'products' ? (
                    <span className="text-ellipsis">
                      {dimensionObj.products.join(', ')}
                    </span>
                  ) : header.value === 'dimensions' ? (
                    <span className="text-ellipsis">
                      {dimensionObj.dimensions.join(', ')}
                    </span>
                  ) : header.value === 'data_type' ? (
                    <span>{dimensionObj?.data_type?.name}</span>
                  ) : header.value === 'quality_check_name' ? (
                    <div className="div-flex-row cg-10">
                      <input type="checkbox" className="checkbox-grey" />
                      <button
                        className="icon-btn-none"
                        onClick={() =>
                          moveToDetail(dimensionObj.quality_check_unique_number)
                        }
                      >
                        <span className="text-blue">
                          {dimensionObj[header.value]}
                        </span>
                      </button>
                    </div>
                  ) : (
                    <span>{dimensionObj[header.value]}</span>
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={headers?.length} className="no-data-found border-bottom">
            <span className="text-sm">No Dimensions Created</span>
          </td>
        </tr>
      )}
    </tbody>
  );
}

export default TableContent;
